import { Component } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  constructor() {

  }
  toggleAcc(index: any) {
    switch (index) {
      case 1:
        $("#acc-1").toggleClass("acc-one");
        break;
      case 2:
        $("#acc-2").toggleClass("acc-two");
        break;
      case 3:
        $("#acc-3").toggleClass("acc-three");
        break;
      case 4:
        $("#acc-4").toggleClass("acc-four");
        break;
      case 5:
        $("#acc-5").toggleClass("acc-five");
        break;
        case 6:
          $("#acc-6").toggleClass("acc-six");
          break;
          case 7:
        $("#acc-7").toggleClass("acc-seven");
        break;
        case 8:
        $("#acc-8").toggleClass("acc-eight");
        break;
        case 9:
        $("#acc-9").toggleClass("acc-nine");
        break;
        case 10:
        $("#acc-10").toggleClass("acc-ten");
        break;
        case 11:
        $("#acc-11").toggleClass("acc-eleven");
        break;
        case 12:
        $("#acc-12").toggleClass("acc-twelve");
        break;
        case 13:
        $("#acc-13").toggleClass("acc-thirteen");
        break;  
    }
  }
}
